<!-- Модальная оболочка создания и редактирования заказ-наряда ремонта. -->
<template>
  <BaseModal
    :visible="true"
    :title="title"
    size="wide"
    adaptive-fullscreen
    footer-align="start"
    elevated-footer
    :close-on-escape="false"
    @close="$emit('close')"
  >
    <FleetRepairForm
      :form-id="formId"
      :repair-id="repairId"
      :vehicle-id="vehicleId"
      @close="$emit('close')"
      @loaded="currentRepair = $event"
      @saved="$emit('saved', $event)"
      @submitting-change="isSubmitting = $event"
    />

    <template #footer>
      <base-primary-button
        type="submit"
        :form="formId"
        :disabled="footerIsDisabled"
        class="form-btn"
      >
        {{ saveButtonText }}
      </base-primary-button>
      <base-button
        type="button"
        class="form-btn"
        :disabled="footerIsDisabled"
        @click="$emit('close')"
      >
        Отмена
      </base-button>
      <BaseArchiveRestoreButton
        v-if="repairId && currentRepair"
        class="form-btn archive-btn"
        :archived="repairIsArchived"
        :disabled="footerIsDisabled"
        :loading="archiveActionIsLoading"
        archive-title="Архивировать ремонт?"
        archive-message="Ремонт будет убран из обычного списка. Его можно будет восстановить из архива."
        restore-title="Восстановить ремонт?"
        restore-message="Ремонт снова появится в обычном списке."
        @click="handleArchiveAction"
      />
    </template>
  </BaseModal>
</template>

<script>
import FleetRepairForm from "@/components/Fleet/Repair/Form.vue";

import { useFleetRepairStore } from "@/stores/fleetRepairStore";

export default {
  name: "FleetRepairModal",

  components: {
    FleetRepairForm,
  },

  props: {
    vehicleId: { type: [String, Number], default: null },
    repairId: {
      type: Number,
      default: null,
    },
  },

  emits: ["close", "saved"],

  data() {
    return {
      formId: "fleet-repair-form",
      isSubmitting: false,
      archiveActionIsLoading: false,
      currentRepair: null,
    };
  },

  computed: {
    store() {
      return useFleetRepairStore();
    },

    title() {
      return this.repairId
        ? "Редактирование ремонта"
        : "Новый ремонт";
    },

    repairIsArchived() {
      return Boolean(this.currentRepair?.archived_at);
    },

    footerIsDisabled() {
      return this.isSubmitting || this.archiveActionIsLoading;
    },

    saveButtonText() {
      if (this.isSubmitting) return "Сохранение...";

      return "Сохранить";
    },
  },

  methods: {
    async handleArchiveAction() {
      if (!this.repairId) return;

      this.archiveActionIsLoading = true;
      try {
        let repair;

        if (this.repairIsArchived) {
          repair = await this.store.restoreRepair(this.repairId);
        } else {
          repair = await this.store.archiveRepair(this.repairId);
        }

        this.currentRepair = repair;
      } finally {
        this.archiveActionIsLoading = false;
      }
    },
  },
};
</script>
